import { Form, Header } from 'semantic-ui-react';

import RepeaterDetailsTable from './RepeaterDetailsTable';

/**
 * 新規購入のみ（IncludePurchasedRepeaters === false）向け Trunking / Repeater UI（#415 / T3）。
 * SO# Search・Exchange/Remove・Add Row は提供しない。数量指定で ADD 明細を生成し Model を入力する。
 *
 * @param {{
 *   gen1Order: Object,
 *   validationErrors: Object,
 *   onFormChange: (evn: object, data: object) => void,
 *   onRepeaterLineChange: (lineSequenceNumber: number, field: string, value: string) => void,
 *   onDeleteManualRepeaterRow: (lineSequenceNumber: number) => void,
 * }} props
 */
export default function Gen1ApplicationNewPurchaseTrunking({
    gen1Order,
    validationErrors = {},
    onFormChange,
    onRepeaterLineChange,
    onDeleteManualRepeaterRow,
}) {
    const item = gen1Order?.Gen1TrunkingOrderItem ?? {};
    const repeaterLines = gen1Order?.Gen1TrunkingOrderRepeaterSerials ?? [];
    const repeaterQty = Number(item.RepeaterQty) || 0;
    const systemType = gen1Order?.SystemType ?? '';
    const hasAddRepeaterOperationsError =
        !!validationErrors.addRepeaterOperations;

    return (
        <>
            <Header
                as="h4"
                content="Repeater Operations"
                style={{ marginTop: 24 }}
            />
            <p
                style={{
                    color: 'rgba(0,0,0,0.65)',
                    fontSize: '0.9em',
                    marginBottom: 12,
                    maxWidth: 720,
                }}
            >
                Enter the number of repeaters to order. Repeater detail rows are
                generated from the quantity; enter Model for each row.
            </p>
            <Form.Group widths="equal">
                <Form.Input
                    required
                    label="KSGPG91800 Repeater Trunking Feature"
                    type="number"
                    min={0}
                    name="RepeaterQty"
                    value={item.RepeaterQty ?? 0}
                    onChange={onFormChange}
                    error={
                        !!validationErrors.repeaterQty ||
                        hasAddRepeaterOperationsError
                    }
                />
                <Form.Input
                    type="number"
                    min={0}
                    name="MultiSiteNetworkingQty"
                    label="KSGPG91810 Multi_site Networking Feature"
                    value={item.MultiSiteNetworkingQty ?? 0}
                    onChange={onFormChange}
                    error={
                        !!validationErrors.multiSiteNetworkingQty ||
                        hasAddRepeaterOperationsError
                    }
                />
            </Form.Group>

            {repeaterQty > 0 && (
                <>
                    <Header
                        as="h4"
                        content="Repeater Details"
                        style={{ marginTop: 24 }}
                    />
                    <RepeaterDetailsTable
                        newPurchaseOnly
                        repeaterLines={repeaterLines}
                        systemType={systemType}
                        systemId={gen1Order?.SystemId ?? ''}
                        addRepeater
                        repeaterTrunkingQty={repeaterQty}
                        exchangeRepeater={false}
                        exchangeRepeaterQuantity={0}
                        removeRepeater={false}
                        removeRepeaterQuantity={0}
                        validationErrors={validationErrors}
                        onRepeaterLineChange={onRepeaterLineChange}
                        onDeleteManualRepeaterRow={onDeleteManualRepeaterRow}
                    />
                </>
            )}
        </>
    );
}
